import * as React from 'react';
import { connect } from 'react-redux';
import { ApplicationState } from '../../../store';
import { SftpImportConfigurationWorkflow } from '../../../store/Models/Api/SftpImportModels';
import { ToxnotComponent, ToxnotComponentProperties } from '../../core/BaseApplicationComponents/ToxnotComponent';
import { SupplierDefaultHandlingPanel } from './SupplierDefaultHandlingPanel';
import { BomDefaultHandlingPanel } from './BomDefaultHandlingPanel';
import { MultipleBomDefaultHandlingPanel } from './MultipleBomDefaultHandlingPanel';

interface DefaultHandlingPanelLocalProps {
    config: SftpImportConfigurationWorkflow;
}

type DefaultHandlingPanelProps = DefaultHandlingPanelLocalProps & ToxnotComponentProperties;

class DefaultHandlingPanelComponent extends ToxnotComponent<DefaultHandlingPanelProps> {
    render() {
        const { config } = this.props;
        
        const isSupplierImport = config.importType === 2; // Suppliers
        const isSingleImport = config.inventoryMode === 0 && !isSupplierImport; // 0 = One

        if (isSupplierImport) {
            return <SupplierDefaultHandlingPanel config={config} />;
        } else if (isSingleImport) {
            return <BomDefaultHandlingPanel config={config} />;
        } else {
            return <MultipleBomDefaultHandlingPanel config={config} />;
        }
    }
}

export const DefaultHandlingPanel = connect(
    (state: ApplicationState) => ({ appServices: state.appServices! })
)(DefaultHandlingPanelComponent);
